export const setBucketListItems = (items) => ({
	type: 'BL_SET_ITEMS',
	items
});